import type { PlainDateString } from "@sa-nu/shared-utils/date";

export type FeeItem = {
  label: string;
  amount: number;
  night?: PlainDateString | null;
  key?: string | null;
};

export type GroupedFeeItem = FeeItem & {
  hasDynamicPricing?: boolean;
  hasFridaySundayFee?: boolean;
  hasAdditionalGuestFee?: boolean;
};

export function groupFeeItemByNight(items: FeeItem[]): GroupedFeeItem[] {
  const itemForNight = items.filter((item) => item.night);
  const itemForNotNight = items.filter((item) => !item.night);

  const nightMap = new Map<PlainDateString, GroupedFeeItem>();
  for (const item of itemForNight) {
    const night = item.night;
    if (!night) continue;

    const existing = nightMap.get(night);
    if (existing) {
      existing.amount += item.amount;
      if (item.key === "calculated_dynamic_pricing_fee") {
        existing.hasDynamicPricing = true;
      }
      if (item.key === "friday_sunday_original") {
        existing.hasFridaySundayFee = true;
      }
      if (item.key === "calculated_additional_guest_fee") {
        existing.hasAdditionalGuestFee = true;
      }
    } else {
      nightMap.set(night, {
        night,
        amount: item.amount,
        label: "",
        hasDynamicPricing: item.key === "calculated_dynamic_pricing_fee",
        hasFridaySundayFee: item.key === "friday_sunday_original",
        hasAdditionalGuestFee: item.key === "calculated_additional_guest_fee",
      });
    }
  }

  return Array.from(nightMap.values()).concat(itemForNotNight);
}
